<div (click)="drawer.open()">
    <ng-content></ng-content>
</div>

<ca-drawer #drawer [bodyBordered]="true" (visibleChange)="onVisibleChange($event)">
    <h2 drawer-header class="ca-headline-2 ca-bold m-0">{{ headerText() | translate }}</h2>
    <div drawer-body class="flex flex-col gap-4" [formGroup]="form">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 w-full">
            <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="ca-form-field ca-form-field-m ca-form-field-w-full with-label with-error-message w-full"
            >
                <mat-label>{{ 'RBR.ROOM_EDITOR.TYPE.LABEL' | translate }}</mat-label>
                <mat-select formControlName="type" placeholder="{{ 'RBR.ROOM_EDITOR.TYPE.PLACEHOLDER' | translate }}">
                    @for (roomType of roomTypes; track roomType) {
                        <mat-option [value]="roomType">{{ 'RBR.ROOM_TYPE.' + roomType | translate }}</mat-option>
                    }
                </mat-select>
                <mat-error>
                    @if (form.controls.type.hasError('required')) {
                        <ca-form-error-message> {{ 'RBR.ROOM_EDITOR.TYPE.REQUIRED' | translate }} </ca-form-error-message>
                    }
                </mat-error>
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="ca-form-field ca-form-field-m ca-form-field-w-full with-label with-error-message w-full"
            >
                <mat-label>{{ 'RBR.ROOM_EDITOR.LEVEL.LABEL' | translate }}</mat-label>
                <mat-select formControlName="levelId" placeholder="{{ 'RBR.ROOM_EDITOR.LEVEL.PLACEHOLDER' | translate }}">
                    @for (level of levels(); track level.id) {
                        <mat-option [value]="level.id">{{ level.position | levelName }}</mat-option>
                    }
                </mat-select>
                <mat-error>
                    @if (form.controls.levelId.hasError('required')) {
                        <ca-form-error-message> {{ 'RBR.ROOM_EDITOR.LEVEL.REQUIRED' | translate }} </ca-form-error-message>
                    }
                </mat-error>
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="ca-form-field ca-form-field-m ca-form-field-w-full with-label with-error-message w-full"
            >
                <mat-label>{{ 'RBR.ROOM_EDITOR.AREA.LABEL' | translate }}</mat-label>
                <input
                    matInput
                    type="number"
                    step="0.01"
                    [min]="areaMin"
                    [max]="areaMax"
                    formControlName="area"
                    placeholder="{{ 'RBR.ROOM_EDITOR.AREA.PLACEHOLDER' | translate }}"
                />
                <mat-error>
                    @if (form.controls.area.hasError('required')) {
                        <ca-form-error-message> {{ 'RBR.ROOM_EDITOR.AREA.REQUIRED' | translate }} </ca-form-error-message>
                    }
                    @if (form.controls.area.hasError('min')) {
                        <ca-form-error-message> {{ 'RBR.ROOM_EDITOR.AREA.MIN' | translate: { min: 0 } }} </ca-form-error-message>
                    }
                    @if (form.controls.area.hasError('max')) {
                        <ca-form-error-message> {{ 'RBR.ROOM_EDITOR.AREA.MAX' | translate: { max: 100 } }} </ca-form-error-message>
                    }
                </mat-error>
            </mat-form-field>
            <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="ca-form-field ca-form-field-m ca-form-field-w-full with-label with-error-message w-full"
            >
                <mat-label>{{ 'RBR.ROOM_EDITOR.HEIGHT.LABEL' | translate }}</mat-label>
                <input
                    matInput
                    type="number"
                    step="0.01"
                    [min]="heightMin"
                    [max]="heightMax"
                    formControlName="height"
                    placeholder="{{ 'RBR.ROOM_EDITOR.HEIGHT.PLACEHOLDER' | translate }}"
                />
                <mat-error>
                    @if (form.controls.height.hasError('required')) {
                        <ca-form-error-message> {{ 'RBR.ROOM_EDITOR.HEIGHT.REQUIRED' | translate }} </ca-form-error-message>
                    }
                    @if (form.controls.height.hasError('min')) {
                        <ca-form-error-message> {{ 'RBR.ROOM_EDITOR.HEIGHT.MIN' | translate: { min: 0 } }} </ca-form-error-message>
                    }
                    @if (form.controls.height.hasError('max')) {
                        <ca-form-error-message> {{ 'RBR.ROOM_EDITOR.HEIGHT.MAX' | translate: { max: 5 } }} </ca-form-error-message>
                    }
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <div class="ca-text-xl ca-bold pt-6 pb-2">{{ 'RBR.ROOM_EDITOR.FUNCTIONS' | translate }}</div>
            <div class="flex align-center gap-12">
                <ca-toggle [value]="form.controls.isCooled.value" (valueChanged)="form.controls.isCooled.setValue($event)">
                    {{ 'RBR.ROOM_EDITOR.COOLING' | translate }}
                </ca-toggle>
                <ca-toggle [value]="form.controls.isHeated.value" (valueChanged)="form.controls.isHeated.setValue($event)">
                    {{ 'RBR.ROOM_EDITOR.HEATING' | translate }}
                </ca-toggle>
            </div>
        </div>
        <mat-divider class="my-6" />
        <div>TODO: Question Flow goes here</div>
    </div>
    <button drawer-footer mat-stroked-button class="ca-button ca-button-m" (click)="drawer.close()">
        <span>{{ 'CA.BUTTON.CANCEL' | translate }}</span>
    </button>
    <button drawer-footer mat-flat-button class="ca-button ca-button-m" (click)="onConfirm(drawer)">
        <span>{{ 'CA.BUTTON.CONFIRM' | translate }}</span>
    </button>
</ca-drawer>
